import React from 'react';
import {Box} from '@mui/material';
import MuiFabButtonBack from "../mui/mui_buttons/fab/extended/MuiFabButtonBack";


interface OnCloseTableProps {
    onClose: () => void;
}

const OnCloseTable: React.FC<OnCloseTableProps> = ({onClose}) => {
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="5%"
        >
            <Box className='mt-2 gap-x-2 mb-2'>
                <MuiFabButtonBack onClick={onClose}/>
            </Box>
        </Box>
    );
};

export default OnCloseTable;